import styled from 'styled-components';
import { Text, Box } from '@rsos/components/capstone/base';

export const ThreeItemRow = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 10px;
`;
export const TwoItemRow = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
`;
export const Title = styled(Text).attrs({
  size: 'header',
  fontWeight: 'bold',
  mt: 20,
  mb: '10px',
  color: 'primaryText',
})``;

export const Description = styled(Text).attrs({
  size: 'normal',
  fontWeight: 'bold',
  color: 'primaryText',
})``;

export const SelectWrapper = styled(Box).attrs({
  flow: 7,
  grow: true,
})``;
